module.exports = "/images/378f8249e7c78c70ef84b3f844f086ff.png";